import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const vi: Translations = {
  common: {
    appName: appName,
    loading: 'Đang tải...',
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    back: 'Quay lại',
    search: 'Tìm kiếm',
    noResults: 'Không có kết quả',
    error: 'Đã xảy ra lỗi',
    success: 'Thành công',
  },
  header: {
    searchPlaceholder: 'Tìm coser, hotgirl, áo dài, model...',
    searchPlaceholderMobile: 'Tìm kiếm...',
    home: 'Trang chủ',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Model',
    upload: 'Đăng ảnh',
    notifications: 'Thông báo',
    login: 'Đăng nhập',
    register: 'Đăng ký',
  },
  footer: {
    tagline: `Nền tảng chia sẻ ảnh Coser, Hotgirl, Model đẹp nhất trên ${appName}.`,
    copyright: `© {year} ${appName}. All rights reserved.`,
    sections: {
      explore: 'Khám phá',
      account: 'Tài khoản',
      support: 'Hỗ trợ',
    },
    links: {
      home: 'Trang chủ',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Model',
      aoDai: 'Áo dài',
      login: 'Đăng nhập',
      register: 'Đăng ký',
      upload: 'Đăng ảnh',
      dashboard: 'Dashboard',
      terms: 'Điều khoản',
      privacy: 'Bảo mật',
      report: 'Báo cáo vi phạm',
      contact: 'Liên hệ',
    },
  },
  collections: {
    title: 'Bộ sưu tập',
    createAlbum: 'Tạo album',
    saved: 'Đã lưu',
    noSaved: 'Chưa có ảnh nào được lưu',
    noSavedHint: 'Khám phá ảnh ngay →',
    removedSave: 'Đã bỏ lưu',
    createModalTitle: 'Tạo album mới',
    albumNamePlaceholder: 'Tên album...',
    cancel: 'Hủy',
    create: 'Tạo',
    albumCreated: 'Đã tạo album',
  },
  home: {
    title: 'Khám phá',
    titleHighlight: 'vẻ đẹp',
    titleSuffix: 'của cuộc sống',
    subtitle: 'Hàng nghìn ảnh Coser, Hotgirl, Model được cập nhật mỗi ngày',
    sortNewest: 'Mới nhất',
    sortTrending: 'Xu hướng',
    sortPopular: 'Phổ biến',
    allCategories: 'Tất cả',
    noMorePosts: 'Bạn đã xem tất cả ảnh',
  },
  auth: {
    login: {
      title: 'Đăng nhập để tiếp tục',
      continueWithGoogle: 'Tiếp tục với Google',
      orLoginWithEmail: 'hoặc đăng nhập bằng email',
      email: 'Email',
      password: 'Mật khẩu',
      forgotPassword: 'Quên mật khẩu?',
      submitButton: 'Đăng nhập',
      loading: 'Đang đăng nhập...',
      noAccount: 'Chưa có tài khoản?',
      registerLink: 'Đăng ký ngay',
      errorCredentials: 'Email hoặc mật khẩu không đúng',
      successLogin: 'Đăng nhập thành công!',
    },
    register: {
      title: 'Tạo tài khoản miễn phí',
      displayName: 'Tên hiển thị',
      displayNamePlaceholder: 'Nguyễn Văn A',
      email: 'Email',
      password: 'Mật khẩu',
      passwordPlaceholder: 'Tối thiểu 8 ký tự',
      confirmPassword: 'Xác nhận mật khẩu',
      submitButton: 'Đăng ký',
      loading: 'Đang tạo tài khoản...',
      hasAccount: 'Đã có tài khoản?',
      loginLink: 'Đăng nhập',
      errorPasswordMismatch: 'Mật khẩu không khớp',
      errorPasswordLength: 'Mật khẩu tối thiểu 8 ký tự',
      errorGeneric: 'Đăng ký thất bại',
      successRegister: 'Đăng ký thành công!',
      emailTaken: 'Email đã được sử dụng',
      serverError: 'Lỗi server, vui lòng thử lại sau',
    },
    forgotPassword: {
      title: 'Quên mật khẩu',
      subtitle: 'Nhập email để nhận liên kết đặt lại mật khẩu',
      email: 'Email',
      submitButton: 'Gửi liên kết',
      backToLogin: 'Quay lại đăng nhập',
      sending: 'Đang gửi...',
      emailSent: 'Đã gửi email!',
      checkEmail: 'Kiểm tra hộp thư {email} để nhận link đặt lại mật khẩu.',
      instructions: 'Nhập email của bạn và chúng tôi sẽ gửi link để đặt lại mật khẩu.',
    },
  },
  userMenu: {
    dashboard: 'Dashboard',
    collections: 'Bộ sưu tập',
    settings: 'Cài đặt',
    logout: 'Đăng xuất',
  },
  settings: {
    title: 'Cài đặt tài khoản',
    profile: {
      nav: 'Hồ sơ',
      title: 'Thông tin hồ sơ',
      displayName: 'Tên hiển thị',
      username: 'Username',
      website: 'Website',
      bio: 'Bio',
      bioPlaceholder: 'Giới thiệu về bản thân...',
      changeAvatar: 'Đổi ảnh đại diện',
      avatarHint: 'JPG, PNG, WebP tối đa 5MB',
      saveButton: 'Lưu thay đổi',
      saving: 'Đang lưu...',
      savedSuccess: 'Đã lưu thay đổi',
    },
    password: { 
      nav: 'Mật khẩu',
      title: 'Đổi mật khẩu',
      fields: {
        currentPassword: 'Mật khẩu hiện tại',
        newPassword: 'Mật khẩu mới',
        confirm: 'Xác nhận mật khẩu mới',
      },
      errors: {
        confirm: 'Mật khẩu mới không khớp',
        minLength: 'Mật khẩu tối thiểu 8 ký tự',
      },
      success: 'Đã đổi mật khẩu',
      saving: 'Đang lưu...',
      submit: 'Đổi mật khẩu',
    },
    notifications: { 
      nav: 'Thông báo',
      title: 'Cài đặt thông báo',
      options: {
        likes: 'Khi có người thích ảnh của bạn',
        comments: 'Khi có người bình luận',
        replies: 'Khi có người trả lời bình luận của bạn',
        follows: 'Khi có người theo dõi bạn',
        approved: 'Khi bài viết được duyệt',
        email_digest: 'Email tổng hợp hàng tuần',
        marketing: 'Thông báo khuyến mãi, sự kiện',
      },
      saveSuccess: 'Đã lưu cài đặt thông báo',
      saving: 'Đang lưu...',
      saveButton: 'Lưu cài đặt',
    },
    security: {
      nav: 'Bảo mật',
      twoFactorAuth: 'Xác thực 2 bước (2FA)',
      twoFactorAuthHint: 'Tăng bảo mật với mã xác thực từ ứng dụng',
      comingSoon: 'Sắp ra mắt',
      activeSessions: 'Phiên đăng nhập',
      currentBrowser: 'Trình duyệt hiện tại',
      lastLogin: 'Đăng nhập lần này',
      active: 'Hoạt động',
      dangerZone: 'Vùng nguy hiểm',
      deleteAccountHint: 'Xóa tài khoản sẽ xóa vĩnh viễn tất cả dữ liệu của bạn.',
      deleteAccount: 'Xóa tài khoản',
    },
  },
  post: {
    likes: '{count} lượt thích',
    views: '{count} lượt xem',
    shares: '{count} lượt chia sẻ',
    comments: '{count} Bình luận',
    save: 'Lưu',
    saved: 'Đã lưu',
    share: 'Chia sẻ',
    linkCopied: 'Đã copy link chia sẻ!',
    follow: 'Theo dõi',
    following: 'Đang theo dõi',
    relatedPosts: 'Bài đăng liên quan',
    commentPlaceholder: 'Viết bình luận...',
    commentLoginPlaceholder: 'Đăng nhập để bình luận...',
    commentSubmit: 'Đăng',
    commentSubmitting: 'Đang đăng...',
    noComments: 'Chưa có bình luận. Hãy là người đầu tiên!',
    savedToCollection: 'Đã lưu vào bộ sưu tập',
    removedFromCollection: 'Đã bỏ lưu',
    description: 'Mô tả',
    profileView: 'Xem trang cá nhân',
  },
  notifications: {
    title: 'Thông báo',
    empty: 'Không có thông báo',
    markAllRead: 'Đánh dấu đã đọc tất cả',
    types: {
      like_post: 'đã thích ảnh của bạn',
      comment: 'đã bình luận về ảnh của bạn',
      reply: 'đã trả lời bình luận của bạn',
      follow: 'đã theo dõi bạn',
      approve: 'Bài viết của bạn đã được duyệt',
      reject: 'Bài viết của bạn đã bị từ chối',
      system: 'Thông báo hệ thống',
    },
  },
  search: {
    title: 'Kết quả tìm kiếm cho',
    result: 'Kết quả',
    tryOtherKeywords: 'Thử với từ khóa khác nhé',
    noResults: 'Không tìm thấy kết quả cho',
    placeholder: 'Tìm kiếm...',
    thisHashtag: 'ảnh với hashtag này',
  },
  upload: {
    title: 'Đăng ảnh',
    dragDrop: 'Kéo thả hoặc click để chọn ảnh',
    supportedFormats: 'Hỗ trợ JPG, PNG, WebP, GIF',
    submit: 'Đăng bài',
    submitting: 'Đang đăng...',
    titleField: 'Tiêu đề',
    titlePlaceholder: 'Nhập tiêu đề hấp dẫn...',
    descriptionField: 'Mô tả',
    descriptionPlaceholder: 'Mô tả chi tiết về bộ ảnh...',
    hashtagsField: 'Hashtags',
    statusField: 'Trạng thái',
    statusPublic: 'Công khai',
    statusPrivate: 'Riêng tư',
    statusDraft: 'Nháp',
    error: 'Lỗi khi upload',
    errorSelect: 'Chọn ít nhất 1 ảnh',
    errorTitle: 'Nhập tiêu đề',
    photos: 'ảnh',
    uploading: 'Đang tải lên...',
  },
  notFound: {
    title: 'Không tìm thấy trang',
    subtitle: 'Trang bạn tìm kiếm không tồn tại.',
    backHome: 'Về trang chủ',
  },
  liked: {
    title: 'Bài viết đã thích',
    empty: 'Chưa có bài viết nào được thích',
  },
  user: {
    unknown: 'Ẩn danh',
  },
  globalError: {
    title: 'Có lỗi xảy ra',
    subtitle: 'Xin lỗi vì sự bất tiện này. Vui lòng thử lại.',
    retry: 'Thử lại',
  },
  username: {
    posts: 'Bài đăng',
    likes: 'Lượt thích',
    followers: 'Người theo dõi',
    following: 'Đang theo',
    editProfile: 'Chỉnh sửa hồ sơ',
    message: 'Nhắn tin',
    noPosts: 'Chưa có bài đăng nào',
    bio: 'Xem ảnh của ',
    notFound: 'Người dùng không tồn tại',
  },
  topic: {
    notFound: 'Chủ đề không tồn tại',
    viewTitle: 'Xem ảnh chủ đề ',
  },
  dashboard: {
    title: 'Bảng điều khiển',
    welcome: 'Xin chào',
    stats: {
      posts: 'Bài đăng',
      views: 'Lượt xem',
      likes: 'Lượt thích',
      comments: 'Bình luận',
    },
  },
  adsblock: {
    title: 'Bạn đang dùng AdBlock',
    description: 'Tắt AdBlock để xem ảnh chất lượng cao và hỗ trợ chúng tôi duy trì website miễn phí.',
    action: 'Tôi đã tắt — Tải lại',
    cancel: 'Bỏ qua' 
  },
  pwa: {
    title: `Cài đặt ${appName} để trải nghiệm tốt hơn!`,
    iosSubtitle: `Nhấn Share → Add to Home Screen`,
    androidSubtitle: `Nhận thông báo bộ ảnh mới ngay khi ra mắt`,
    installButton: `Cài đặt ${appName}`,
    disclaimer: `Cài đặt nhanh, không cần app store.`,
  },
  autotrans: {
    title: 'Dịch tự động',
    translated: 'Bản Dịch',
    origin: 'Nội dung gốc',
  },
  subscription: {
    title: 'Đăng ký nhận thông báo',
    description: 'Nhận thông báo về các bộ ảnh mới ngay khi chúng được phát hành.',
    subscribeButton: 'Đăng ký',
    unsubscribeButton: 'Hủy đăng ký',
    subscribed: 'Bạn đã đăng ký nhận thông báo.',
    unsubscribed: 'Bạn đã hủy đăng ký nhận thông báo.',
    error: 'Đã xảy ra lỗi khi cập nhật đăng ký của bạn. Vui lòng thử lại.',
    success_tit: '🎉 Đã bật thông báo!',
    denied_tit: 'Đã từ chối thông báo',
    error_tit: 'Có lỗi xảy ra',
    success_des: 'Bạn sẽ nhận được thông báo khi có nội dung mới.',
    denied_des: 'Bạn có thể bật lại trong cài đặt trình duyệt.',
    error_des: 'Vui lòng thử lại sau.',
    skip: 'Bỏ qua',
    processing: 'Đang xử lý...',
    noti: 'Bật Thông Báo',
    rule: 'Chỉ hiển thị thông báo cho nội dung mới.',
    notify_title: `Thông báo mới! - ${appName}`,
    notify_body: "Bộ ảnh mới đã được phát hành. Hãy khám phá ngay!",
  },
  contact: {
    title: 'Liên hệ',
    subtitle: 'Chúng tôi rất muốn nghe ý kiến của bạn! Vui lòng điền vào mẫu dưới đây và chúng tôi sẽ phản hồi bạn sớm nhất có thể.',
    name: 'Tên',
    email: 'Email',
    subject: 'Chủ đề',
    message: 'Tin nhắn',
    submitButton: 'Gửi tin nhắn',
    sending: 'Đang gửi...',
    successTitle: 'Tin nhắn đã được gửi!',
    successMessage: 'Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi bạn sớm.',
    errorTitle: 'Đã xảy ra lỗi',
    errorMessage: 'Đã xảy ra lỗi khi gửi tin nhắn của bạn. Vui lòng thử lại sau.',
    res_time_title: 'Thời gian phản hồi',
    res_time: 'Chúng tôi thường phản hồi trong vòng 1–3 ngày làm việc.',
    report_content: 'Báo cáo nội dung',
    report_content_hint: 'Để báo cáo một bài viết hoặc người dùng, hãy sử dụng nút báo cáo trực tiếp trên nội dung hoặc chọn &ldquo;Báo cáo nội dung&rdquo; ở trên.',
    value_default: 'Chọn một chủ đề',
    value_general: 'Yêu cầu chung',
    value_report: 'Báo cáo nội dung',
    value_account: 'Vấn đề tài khoản',
    value_business: 'Kinh doanh / hợp tác',
    value_feedback: 'Phản hồi & gợi ý',
    value_other: 'Khác'
  },
  language: {
    label: `Ngôn ngữ`,
    en: `English`,
    vi: `Tiếng Việt`,
    zh: `中文`,
    ja: `日本語`,
    ko: `한국어`,
    ar: `العربية`,
    fr: `Français`,
    es: `Español`,
    ru: `Русский`,
    hi: `हिन्दी`,
    id: `Indonesia`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
  },
};

export default vi;
